import { render, staticRenderFns } from "./EditAuthorizationDocumentDialog.vue?vue&type=template&id=c07a854a&"
import script from "./EditAuthorizationDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./EditAuthorizationDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports